import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-leilao09',
  templateUrl: './leilao09.component.html',
  styleUrls: ['./leilao09.component.scss']
})
export class Leilao09Component implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
  }

  voltar(){
    this.router.navigate([''], { relativeTo: this.route });
  }

}
